import '@client/layouts/layout_common/layout_common'
import './landingpage.scss'
import '@client/components/spinner/spinner'
import './cta'
